import styled from '@emotion/styled';
import { Alert as MUIAlert } from '@mui/material';
import tailwindConfig from '../../../tailwind.config';

export const Alert = styled(MUIAlert)({
  borderRadius: tailwindConfig.theme.extend.borderRadius.DEFAULT,
});
